import type { ApiResult } from '@/infra/api'
import { API_ENDPOINTS, httpPost } from '@/infra/api'
import type { ApiKeyGenerationRequest, ApiKeyResponse } from '../types'

export const apiKeyClient = {
  generateApiKey(request: ApiKeyGenerationRequest): Promise<ApiResult<ApiKeyResponse>> {
    return httpPost<ApiKeyResponse>(API_ENDPOINTS.API_KEY_GENERATE, request)
  },
}
